import ChecklistItem from "../../../../../models/checklist/checklist-item/checklist-item";
import ChecklistItemStatus from "../../../../../models/checklist/checklist-item/checklist-item-status";
const useMergedStatus = (item: ChecklistItem) => {
  const cardStatus: ChecklistItemStatus = item.status;
  return cardStatus;
};

export default useMergedStatus;
